const nationals = {
  1: 'nswisa',
  2: 'dsa',
  3: 'kanga',
};
  
const errors = {
  phone: 'Please enter a valid number',
  emails: 'Please enter valid emails',
  email: 'Please enter a valid email',
  password: 'Password must be at least 8 characters with uppercase letters, lowercase letters and special characters.',
  select_option: 'Please select an option',
  input_option: 'Field is required',
};
  
  
const entityTypes = [
  {
    name: 'State',
    type: 'state'
  },
  {
    name: 'Association',
    type: 'association'
  },
  // {
  //   name: 'Club',
  //   type: 'club'
  // }
];
  
const genders = [
  'Male',
  'Female',
  'All',
];
  
const matchStatus = [
  { value: 'pre-game', label: 'Pre-Game' },
  { value: 'final', label: 'Final' },
  { value: 'forfeit', label: 'Forfeit' },
  { value: 'disputed', label: 'Disputed' },
  { value: 'washout', label: 'Washout' }
];
  
const seasons = [
  { value: 2021, default: false },
  { value: 2022, default: true },
];
const defaultSeason = 2022;
  
  

const weatherCodes = [
  { value: 0, label: 'Unknown' },
  { value: 1000, label: 'Clear', icon: 'clear_day' },
  { value: 1001, label: 'Cloudy', icon: 'cloudy' },
  { value: 1100, label: 'Mostly Clear', icon: 'mostly_clear_day' },
  { value: 1101, label: 'Partly Cloudy', icon: 'party_cloudy_day' },
  { value: 1102, label: 'Mostly Cloudy', icon: 'mostly_cloudy' },
  { value: 2000, label: 'Fog', icon: 'fog' },
  { value: 2100, label: 'Light Fog', icon: 'fog_light' },
  { value: 3000, label: 'Light Wind', icon: 'wind_light' },
  { value: 3001, label: 'Wind', icon: 'wind' },
  { value: 3002, label: 'Strong Wind', icon: 'wind' },
  { value: 4000, label: 'Drizzle', icon: 'drizzle' },
  { value: 4001, label: 'Rain', icon: 'rain' },
  { value: 4200, label: 'Light Rain', icon: 'rain_light' },
  { value: 4201, label: 'Heavy Rain', icon: 'rain_heavy' },
  { value: 5000, label: 'Snow', icon: 'snow' },
  { value: 5001, label: 'Flurries', icon: 'flurries' },
  { value: 5100, label: 'Light Snow', icon: 'snow_light' },
  { value: 5101, label: 'Heavy Snow', icon: 'snow_heavy' },
  { value: 6000, label: 'Freezing Drizzle', icon: 'freezing_drizzle' },
  { value: 6001, label: 'Freezing Rain', icon: 'freezing_rain' },
  { value: 6200, label: 'Light Freezing Rain', icon: 'freezing_rain_light' },
  { value: 6201, label: 'Heavy Freezing Rain', icon: 'freezing_rain_heavy' },
  { value: 7000, label: 'Ice Pellets', icon: 'ice_pellets' },
  { value: 7101, label: 'Heavy Ice Pellets', icon: 'ice_pellets_heavy' },
  { value: 7102, label: 'Light Ice Pellets', icon: 'ice_pellets_light' },
  { value: 8000, label: 'Thunderstorm', icon: 'tstorm' },
];

module.exports = {
  errors,
  genders,
  matchStatus,
  seasons,
  defaultSeason,
  nationals,
  entityTypes,
  weatherCodes
};
  